<template>
    <TitleCommon title="SETTINGS" :isShowButtonBack="true" />
    <Print />
</template>
<script>
import TitleCommon from '@/components/common/title/index.vue';
import Print from '@/components/print/print.vue';

export default {
    components: { Print, TitleCommon },
};
</script>
<style lang="scss">
@import '@/public/scss/print/print.scss';
</style>
